export const CURRENCY_INPUT_TEST_ID = {
  ROOT: 'currency-input',
  INPUT: 'currency-input-element',
};
